import { injectStrict } from '@/injection/injectStrict.ts';
import { ApiKey } from '@/injection/keys.ts';
import { ApiRequestParams } from '@/types/api.type.ts';
import {
    DeliveryPrice,
    DeliveryPriceSchema,
    DeliveryPricesPaginator,
    DeliveryPricesPaginatorSchema,
    DeliveryPricesRequestFilter,
    DeliveryPriceUpdateForm,
    DeliveryPriceUpdateFormErrors,
    DeliveryPriceUpdateFormErrorsSchema,
} from '@/types/delivery-price.type.ts';

class DeliveryPriceRepository
{
    private $Api: any;

    constructor() {
        this.$Api = injectStrict(ApiKey);
    }

    public getDeliveryPrices(requestFilter?: DeliveryPricesRequestFilter): Promise<DeliveryPricesPaginator>
    {
        const requestParams: ApiRequestParams = {
            query: requestFilter,
        };

        return new Promise((resolve) => {
            this.$Api.callNew('getDeliveryPrices', requestParams)
                .then(({ data }: any) => {
                    const parsedDeliveryPricesPaginator = DeliveryPricesPaginatorSchema.parse(data);
                    const deliveryPricesPaginator: DeliveryPricesPaginator = parsedDeliveryPricesPaginator as unknown as DeliveryPricesPaginator;

                    resolve(deliveryPricesPaginator);
                });
        });
    }

    public deactivateDeliveryPrice(id: number): Promise<void>
    {
        const requestParams: ApiRequestParams = {
            segments: { id },
        };

        return new Promise((resolve) => {
            this.$Api.callNew('deactivateDeliveryPrice', requestParams)
                .then(() => {
                    resolve();
                });
        });
    }

    public getDeliveryPrice(id: number): Promise<DeliveryPrice>
    {
        const requestParams: ApiRequestParams = {
            segments: { id },
        };

        return new Promise((resolve) => {
            this.$Api.callNew('getDeliveryPrice', requestParams)
                .then(({ data }: any) => {
                    const parsedDeliveryPrice = DeliveryPriceSchema.parse(data);
                    const deliveryPrice: DeliveryPrice = parsedDeliveryPrice as unknown as DeliveryPrice;

                    resolve(deliveryPrice);
                });
        });
    }

    public updateDeliveryPrice(id: number, form: DeliveryPriceUpdateForm): Promise<void>
    {
        const requestParams: ApiRequestParams = {
            segments: { id },
            requestBody: form,
        };

        return new Promise((resolve, reject) => {
            this.$Api.callNew('updateDeliveryPrice', requestParams)
                .then(() => resolve())
                .catch(({ response: { status, data: { errors } } }: any) => {
                    if (status === 422) {
                        const parsedErrors = DeliveryPriceUpdateFormErrorsSchema.parse(errors);
                        const updateFormErrors: DeliveryPriceUpdateFormErrors = parsedErrors as unknown as DeliveryPriceUpdateFormErrors;

                        reject(updateFormErrors);
                    }
                    else {
                        reject();
                    }
                });
        });
    }
}

export default DeliveryPriceRepository;
